// Nhãn / icon / link dùng chung cho chuông và trang Trung tâm thông báo.
import React from 'react'
import { CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled, CarOutlined, NotificationFilled } from '@ant-design/icons'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { ROUTES } from 'consts'

dayjs.extend(relativeTime)

export const TABS = [
  { key: 'all', label: 'Tất cả' },
  { key: 'action', label: 'Cần xử lý' },
  { key: 'pushed', label: 'Đã đẩy' },
  { key: 'shipping', label: 'Vận chuyển' },
  { key: 'system', label: 'Hệ thống' },
]

export const TYPE_LABEL = {
  push_pushed: 'Đã đẩy', push_held: 'Giữ lại', push_error: 'Lỗi đẩy', design_blocked: 'Chặn Need pay', design_approve: 'Cần duyệt Design',
  tracking_added: 'Có tracking', order_shipped: 'Shipped', system: 'Hệ thống',
}

export const SUPPLIER_LABEL = { printbelle: 'Printbelle', mangoteeprints: 'Mangoteeprints', bondre: 'Bondre', yunexpress: 'YunExpress' }

export function NotificationIcon({ item }) {
  const style = { fontSize: 18 }
  if (item.type === 'system') return <NotificationFilled style={{ ...style, color: '#722ed1' }} />
  if (item.type === 'tracking_added' || item.type === 'order_shipped') return <CarOutlined style={{ ...style, color: '#13c2c2' }} />
  if (item.severity === 'error') return <CloseCircleFilled style={{ ...style, color: '#ff4d4f' }} />
  if (item.severity === 'warning') return <ExclamationCircleFilled style={{ ...style, color: '#fa8c16' }} />
  return <CheckCircleFilled style={{ ...style, color: '#52c41a' }} />
}

export const timeAgo = (d) => (d ? dayjs(d).locale('vi').fromNow() : '')

/** Link mở đơn: kèm oid để đơn reship (trùng id_order với đơn gốc) mở đúng đơn.
 *  Thông báo gom (vd "Cần duyệt Design") mang sẵn `link` — chỉ nhận đường dẫn nội bộ. */
export const orderLinkOf = (item) =>
  typeof item.link === 'string' && item.link.startsWith('/') && !item.link.startsWith('//')
    ? item.link
    : item.key_design && item.id_order
    ? `${ROUTES.ORDERS_TRACKING_DETAIL}?order=${item.key_design}_${item.id_order}${item.order_id ? `&oid=${item.order_id}` : ''}`
    : null
